import { Button } from "antd";

const UserNotificationColumns = (goToDetailsPage) => [
  {
    title: "Kullanıcı ID",
    dataIndex: ["user", "userId"],
    key: "userId",
    sorter: true,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value || "-"}
      </span>
    ),
  },
  {
    title: "Kullanıcı Rolü",
    dataIndex: ["user", "role"],
    key: "role",
  },
  {
    title: "Bildirim ID",
    dataIndex: ["notification", "id"],
    key: "notificationId",
    sorter: true,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Başlık",
    dataIndex: ["notification", "title"],
    key: "title",
  },
  {
    title: "İçerik",
    dataIndex: ["notification", "body"],
    key: "body",
    ellipsis: true,
  },
  {
    title: "Görsel URL",
    dataIndex: ["notification", "imageUrl"],
    key: "imageUrl",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value || "-"}
      </span>
    ),
  },
  {
    title: "Uygulama",
    dataIndex: ["notification", "app"],
    key: "app",
  },
  {
    title: "Alınma Tarihi",
    dataIndex: "receivedAt",
    key: "receivedAt",
    render: (value) => new Date(value).toLocaleString(),
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    fixed: "right",
    render: (_, record) => (
      <div style={{ display: "flex" }}>
        <Button type="link" onClick={() => goToDetailsPage({ record })}>
          Detaylar
        </Button>
      </div>
    ),
  },
];

export { UserNotificationColumns };
